import { useInvitationPolicy } from '../../features/settings';
import { formatDateTime } from '../../lib/format';

export function InvitationPolicyPage() {
  const { data, loading, saving, error, requireInviteCode, setRequireInviteCode, save, reload } =
    useInvitationPolicy();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="h-6 w-6 border-2 border-gray-300 border-t-primary rounded-full animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="py-20 text-center">
        <p className="text-sm text-red-500 mb-3">{error}</p>
        <button onClick={reload} className="text-sm text-primary hover:underline">
          重试
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-2xl space-y-6">
      <p className="text-sm text-gray-500">
        控制新用户注册时是否必须输入有效邀请码。开启后未持有邀请码的用户将无法完成注册。
      </p>

      <div className="space-y-4">
        <div className="flex items-center gap-4">
          <button
            type="button"
            role="switch"
            aria-checked={requireInviteCode}
            aria-label="注册需要邀请码"
            onClick={() => setRequireInviteCode(!requireInviteCode)}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors shrink-0 ${
              requireInviteCode ? 'bg-primary' : 'bg-gray-300'
            }`}
          >
            <span
              className={`inline-block h-4 w-4 rounded-full bg-white transition-transform ${
                requireInviteCode ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </button>
          <div>
            <span className="text-sm font-medium text-gray-900">注册需要邀请码</span>
            <p className="text-xs text-gray-500 mt-0.5">
              {requireInviteCode
                ? '已开启 — 新用户必须输入有效邀请码才能注册'
                : '已关闭 — 新用户可直接注册，无需邀请码'}
            </p>
          </div>
        </div>

        <div>
          <button
            onClick={save}
            disabled={saving}
            className="inline-flex items-center gap-2 bg-primary text-white rounded-md px-4 py-2 text-sm font-medium hover:bg-primary-hover disabled:opacity-50 transition-colors"
          >
            {saving && (
              <span className="h-4 w-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            )}
            保存
          </button>
        </div>
      </div>

      {data && (
        <div className="pt-4 border-t border-gray-200 text-xs text-gray-400 space-y-1">
          <p>最后更新：{formatDateTime(data.updated_at)}</p>
          {data.updated_by != null && <p>操作人 ID：{data.updated_by}</p>}
        </div>
      )}
    </div>
  );
}
